/**
 * The sender filter's "All" sentinel id; the request leaves it out, so it narrows nothing. Its own
 * module, free of i18n, so the request hooks can read it without loading the translations.
 */
export const ALL_SENDERS_ID = "all";
